import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Unauthenticated")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "You must be authenticated to view application data")
], -1)
const _hoisted_5 = { class: "modal-footer" }

 
    import { useAuth } from '@/stores/auth';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'LoginModal',
  props: {
        show: { type: Boolean, required: true }
    },
  setup(__props) {

    const authState = useAuth();
    const { login } = authState;

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal", [ __props.show ? 'open' : null]]),
    tabindex: "-1",
    role: "dialog",
    style: _normalizeStyle({'display': __props.show ? 'block' : 'none'})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(login) && _unref(login)(...args)))
          }, " Login ")
        ])
      ])
    ])
  ], 6))
}
}

})